export const isValueActive = value => {
    if (value === undefined || value === null) return false;
    if (typeof value === 'string') return value.trim() !== '';
    if (typeof value === 'boolean') return true;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
};

export const getFilterType = (key, value) => {
    if (key === 'period') return 'period';
    if (typeof value === 'boolean') return 'boolean';
    if (Array.isArray(value)) return 'multiselect';
    if (typeof value === 'object') {
        const hasRangeKey = Object.keys(value).some(k => k.endsWith('_gte') || k.endsWith('_lte') || ['from', 'to', 'start', 'end'].includes(k));
        return hasRangeKey ? 'range' : 'object';
    }
    if (typeof value === 'string') {
        const isDateLike = /\d{2}\.\d{2}\.\d{4}/.test(value) || /\d{4}-\d{2}-\d{2}/.test(value) || /T\d{2}:\d{2}:\d{2}/.test(value);
        return isDateLike ? 'date' : 'text';
    }

    return 'unknown';
};

export const getActiveFilters = filterValues =>
    Object.entries(filterValues)
        .filter(([, value]) => isValueActive(value))
        .map(([key, value]) => ({ key, value, type: getFilterType(key, value) }));

const getRangeBaseKey = key => {
    const match = key.match(/^(.*)_(gte|lte)$/);
    return match ? match[1] : null;
};

export const getGroupedActiveFilterCount = activeFilters => {
    const groups = new Map();
    const hasCustomPeriod = activeFilters.some(f => f.key === 'period' && f.value === 'custom');

    for (const f of activeFilters) {
        const base = getRangeBaseKey(f.key);
        if (base) {
            groups.set(base, true);
        } else {
            groups.set(f.key, true);
        }
    }

    if (!hasCustomPeriod) {
        groups.delete('period');
    } else {
        const isCustomPeriodActive = activeFilters.some(f => f.key === 'periodStart_gte' || f.key === 'periodEnd_lte');
        if (!isCustomPeriodActive) {
            groups.delete('period');
        } else {
            groups.set('period', true);
        }
        groups.delete('periodStart');
        groups.delete('periodEnd');
    }

    return groups.size;
};
